const FormatTypes = {
  Generico: 0,
  Data: 1,
  DataOra: 2,
  SoloOra: 3,
  Importo: 4,
  Quantita: 5,
  Ditta: 6,
  Checkbox: 7,
  Articolo: 8,
  PrevMateriali: 9,
  Barcode: 10
};

export default FormatTypes;
